import React, {FC, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {notificationsPortalEl} from "./LayoutProvider";
import {ColourMod} from "../Data/Enums/LayoutEnums";
import ReactDOM from "react-dom";
import useDebounce from "../Hooks/useDebounce";

const ToastsContext = React.createContext<iToastProvider>({} as iToastProvider);

interface iToastProvider {
    addToast: Function;
    removeToast: Function;
    children?: any;
}

interface iToast {
    id: number;
    toast: ToastContent;
    onClick?: Function;
}

type ToastContent = {
    content: any;
    colour?: ColourMod;
    icon?: any;
}

let notificationVisibleTime = 3000;

const Toast: FC<iToast> = (props) => {
    const { removeToast } = useToasts();

    const notificationRef = useRef<HTMLDivElement>(null);
    const progressRef = useRef<SVGCircleElement>(null);

    let hideTimer : any;
    let restartTimer : any;
    
    const Pause = () => {
        clearTimeout(hideTimer);
        
        if (progressRef.current) {
            progressRef.current.style.transitionDuration = '0ms';
            UpdateProgress(0);
        }
    }

    const Restart = () => {
        clearTimeout(restartTimer);
        
        restartTimer = setTimeout(() => {
            Initialise();
        }, 200);
    }

    function SetProgress(percent: number, circumference: number) {
        if(progressRef.current) {
            progressRef.current.style.strokeDashoffset = (circumference - percent / 100 * circumference).toString();
        }
    }

    const UpdateProgress = (value: number) => {
        if(progressRef.current) {
            const radius: number = progressRef.current.r.baseVal.value;
            const circumference: number = radius * 2 * Math.PI;

            progressRef.current.style.strokeDasharray = `${circumference} ${circumference}`;
            progressRef.current.style.strokeDashoffset = `${circumference}`;

            SetProgress(value, circumference);
        }
    }
    
    const Initialise = () => {
        if (progressRef.current) {
            progressRef.current.style.transitionDuration = notificationVisibleTime + 'ms';
        }

        notificationRef.current?.classList.add('active');

        setTimeout(() => {
            UpdateProgress(100);
        }, 200);

        hideTimer = setTimeout(() => {
            notificationRef.current?.classList.remove('active');
/*            setTimeout(() => {
                removeToast(props.id);
            }, notificationVisibleTime + 200 + 200);*/
        }, notificationVisibleTime + 200);
    }
    
    useEffect(() => {
        if(progressRef.current) {
            Initialise();
        }
    }, []);
    
    return (
        ReactDOM.createPortal(
            <div ref={notificationRef} className={`notification timed`} onClick={() => props.onClick ? props.onClick() : null} onMouseOver={() => Pause()} onMouseLeave={() => Restart()}>
                <div className={`notification-icon ${props.toast.colour ? props.toast.colour : 'success' }`}>
                    <svg className='progress-ring' width='72' height='72'>
                        <circle ref={progressRef} className='progress-ring-circle' stroke='currentColor' strokeWidth='4' fill='transparent' r='18' cx='36' cy='36' strokeDasharray={'113.097, 113.097'} strokeDashoffset={'113.097'} />
                    </svg>
                    {props.toast.icon && props.toast.icon}
                </div>
                <div className="notification-content">{props.toast.content}</div>
            </div>,
            notificationsPortalEl
        )
    )
};

const ToastProvider = (props: any) => {
    const [toasts, setToasts] = useState<any>([]);
    const toastsRef = useRef<any>([]);

    const addToast = useCallback((content: string, icon?: any, colour?: ColourMod) => {
        const newToasts = [...toastsRef.current];
        newToasts.push({ toast: { content: content, colour: colour, icon: icon }, id: 'toast213' });

        setToasts(newToasts);
    }, [toasts]);
    
    const removeToast = (id: number) => {
        const newToasts = [...toastsRef.current];
        const filtererdToasts = newToasts.filter((t: any) => t.id !== id);
        setToasts(filtererdToasts);
    };
    
    const toastsMemo = useMemo(() => {
        return {
            addToast,
            removeToast
        }
    }, [toasts]);
    
    useEffect(() => {
        toastsRef.current = toasts;
    }, [toasts]);
    
    return (
        <ToastsContext.Provider value={toastsMemo}>
            {props.children}
            {toasts.map((toast: iToast, index: number) => {
                return (
                    <Toast key={index} id={toast.id} toast={toast.toast} />
                )
            })}
        </ToastsContext.Provider>
    );
}

const useToasts = () => useContext(ToastsContext);

export { ToastsContext, useToasts };

export default ToastProvider